<script setup lang="ts">
	import type { ListContext } from './list-item.vue'

	defineProps<{
		header: string
		subHeader?: string
		summary?: ListContext
		btnText?: string
		noBg?: boolean
		noSummary?: boolean
	}>()
	const emits = defineEmits<{
		(arg: 'proceed'): void
	}>()
</script>

<template>
	<section>
		<shared-card
			:default-class="`max-w-2xl w-full mx-auto p-8 lg:p-20 mt-10 ${noBg ?? '!bg-transparent'}`"
			:ui="{
				container: 'shadow-none'
			}"
		>
			<div class="space-y-6">
				<div class="flex items-center justify-center">
					<lazy-tools-icon dir="fill" icon="success-check" />
				</div>

				<div class="flex flex-col items-center justify-center space-y-2">
					<h3 class="text-center text-2xl font-[700] leading-9 text-blue-950">
						{{ header }}
					</h3>
					<p
						class="text-center text-sm font-medium leading-[20px] text-gray-500 sm:px-20 sm:text-base sm:leading-6"
					>
						{{ subHeader }}
					</p>
				</div>
				<slot name="paragraph">
					<shared-list-item
						v-if="!noSummary"
						class="divide rounded-md border bg-[#FAFAFF]"
						:lists="summary || {}"
					/>
				</slot>
			</div>

			<div class="w-full space-y-5 pt-10">
				<slot name="button-group">
					<button
						v-if="btnText"
						type="button"
						class="w-full rounded-lg bg-primary-2 py-3 text-white"
						@click="emits('proceed')"
					>
						{{ btnText }}
					</button>
				</slot>
			</div>
		</shared-card>
	</section>
</template>
